import Vue from 'vue'
import Router from 'vue-router'
// import Landing from './views/Landing.vue'
// import Menu from './views/Menu.vue'
// import Store from './views/Store.vue'
// import Community from './views/Community.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'landing',
      component: () => import('./views/Landing.vue')
    },
    {
      path: '/store',
      name: 'store',
      component: () => import('./views/Store.vue')
    },
    {
      path: '/menu/:subPage',
      name: 'menu',
      component: () => import('./views/Menu.vue'),
      props: true
    },
    {
      path: '/community',
      name: 'community',
      component: () => import('./views/Community.vue')
    },
    {
      path: '/community/:id',
      name: 'community_id',
      component: () => import('./views/Community.vue'),
      props: true
    }

  ]
})
